// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const bogIron = defineModel({
  id: "bog-iron",
  batchId: "future",
  name: "Bog iron",
  tags: ["scenery","bog","iron","low-poly","age-of-mcp","future"],
  summary: "Iron nodules in a peat bog. Smelted to iron and ground to ochre pigment.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.4,
  parts: () => [
      { geometry: new THREE.CylinderGeometry(0.4, 0.42, 0.06, 11), color: "#54452f", position: [0, 0.03, 0] },
      { geometry: new THREE.IcosahedronGeometry(0.13, 0), color: "#7d4a2a", position: [-0.1, 0.1, 0.04], rotation: [0.2, 0.4, 0.1], scale: [1.2, 0.8, 1.1] },
      { geometry: new THREE.IcosahedronGeometry(0.11, 0), color: "#a25a2c", position: [0.12, 0.09, -0.06], rotation: [0.1, 0.9, 0.2], scale: [1.1, 0.8, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.09, 0), color: "#b86c38", position: [0.04, 0.12, 0.16], rotation: [0.3, 0.2, 0.1] },
      { geometry: new THREE.IcosahedronGeometry(0.07, 0), color: "#7d4a2a", position: [0.22, 0.06, 0.12], rotation: [0.2, 0.5, 0.3] },
      { geometry: new THREE.IcosahedronGeometry(0.06, 0), color: "#a25a2c", position: [-0.24, 0.06, -0.1], rotation: [0.1, 0.8, 0.2] },
    ],
  animations: [],
});
